(ns ycweb.app.website.myaccount.orders.invoice
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.myaccount.orders.common :as orders-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.date :as ud]
   [ycweb.util.urlstate :as urlstate]))

;; Components ===================================================================================================================

(rum/defc order-invoice-line [client-order client-order-item]
  (let [{:client-order/keys [total-price international?]} client-order

        {:client-order-item/keys [comments style price]
         :client-order-item-invoice/keys [line-total line-vat]
         :item-line/keys [qty variation product]} client-order-item

        {:variation/keys [feature1 feature2 feature3]} variation]
    (when (or (not= "Delivery" comments) (> price 0))
      [:tr.yc-invoice-tr
       {:key (:ent/uuid client-order-item)}
       [:td.yc-invoice-td (if (not= "Delivery" comments) "Yuppiechef Products" "Delivery")]
       [:td.yc-invoice-td
        (str/join ", "
          (remove (comp nil? u/presence)
            [(str/join " - "
               (remove (comp nil? u/presence) [(:ent/display-name product) comments style]))
             (str/join ", "
               (remove (comp nil? u/presence) [feature1 feature2 feature3]))]))]
       [:td.yc-invoice-td.yc-invoice-td--center (if (< total-price 0) (* -1 qty) qty)]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format price)]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format line-total)]
       (when (not international?)
         [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format line-vat)])])))

(rum/defc order-invoice-items [app-atom client-order]
  (let [{:client-order/keys [international? items total-price invoice-summary payment-amount billing-details]} client-order
        {:billing/keys [invoice-comments]} billing-details
        {:invoice/keys [total vat]} invoice-summary
        standard-colspan (if international? "1" "2")]

    [:table.yc-invoice-table
     [:colgroup
      [:col {:style {:width "140px"}}]
      [:col {:style {:width "220px"}}]
      [:col]
      [:col]
      [:col]
      [:col]]
     [:thead.yc-invoice-thead
      [:tr.yc-invoice-tr
       [:th.yc-invoice-th {:scope "col"} "Item"]
       [:th.yc-invoice-th {:scope "col"} "Description"]
       [:th.yc-invoice-th.yc-invoice-th--center {:scope "col"} "Qty"]
       [:th.yc-invoice-th.yc-invoice-th--center
        {:scope "col"}
        "Unit Price"]
       [:th.yc-invoice-th.yc-invoice-th--center
        {:scope "col"}
        "Amount"]
       (when (not international?)
         [:th.yc-invoice-th.yc-invoice-th--center
          {:scope "col"}
          "VAT (included)"])]]
     ;Not support "nonegatives" value for international invoices. This was an admin only feature for international orders.
     ;Not needed with no new international orders.
     [:tfoot.yc-invoice-tfoot
      (when (u/presence invoice-comments)
        [:tr.yc-invoice-tr.yc-invoice-tr--comment
         [:td.yc-invoice-td.yc-invoice-td--center {:colSpan (if international? "5" "6")} invoice-comments]])
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td {:colSpan standard-colspan}]
       [:td.yc-invoice-td {:colSpan "3"} [:b "Total:"]]
       [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format total))]]
      (when (not international?)
        [:tr.yc-invoice-tr
         [:td.yc-invoice-td {:colSpan "2"}]
         [:td.yc-invoice-td {:colSpan "3"} [:b "VAT (included):"]]
         [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format vat))]])
      (when (pos? total-price)
        [:tr.yc-invoice-tr
         [:td.yc-invoice-td {:colSpan standard-colspan}]
         [:td.yc-invoice-td {:colSpan "3"} [:b "Payments:"]]
         [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format payment-amount))]])
      (when (pos? total-price)
        [:tr.yc-invoice-tr
         [:td.yc-invoice-td {:colSpan standard-colspan}]
         [:td.yc-invoice-td {:colSpan "3"} [:b "Balance Due:"]]
         [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format (- total-price payment-amount)))]])]
     [:tbody.yc-invoice-tbody
      (map (partial order-invoice-line client-order) items)]]))

(rum/defc registry-invoice-line [client-order-item]
  (let [{:item-line/keys [product variation]
         :client-order-item/keys [comments style price added guest]} client-order-item
        {:variation/keys [feature1 feature2 feature3]} variation]
    (when (or (not= comments "Delivery") (> price 0))
      [:tr.yc-invoice-tr
       {:key (:ent/uuid client-order-item)}
       [:td.yc-invoice-td
        (str/join ", "
          (remove (comp nil? u/presence)
            [(str/join " - "
               (remove (comp nil? u/presence) [(:ent/display-name product) comments style]))
             (str/join ", "
               (remove (comp nil? u/presence) [feature1 feature2 feature3]))]))]
       [:td.yc-invoice-td.yc-invoice-td--center (when (and guest (pos? guest)) (u/currency-format guest))]
       [:td.yc-invoice-td.yc-invoice-td--center (when (and added (pos? added)) (u/currency-format added))]
       [:td.yc-invoice-td.yc-invoice-td--center]])))

(rum/defc registry-invoice-line-removed [client-order-item]
  (let [{:item-line/keys [product variation]
         :client-order-item/keys [comments style price]} client-order-item
        {:variation/keys [feature1 feature2 feature3]} variation]
    (when (or (not= comments "Delivery") (> price 0))
      [:tr.yc-invoice-tr
       {:key (:ent/uuid client-order-item)}
       [:td.yc-invoice-td
        (str/join ", "
          (remove (comp nil? u/presence)
            [(str/join " - "
               (remove (comp nil? u/presence) [(:ent/display-name product) comments style]))
             (str/join ", "
               (remove (comp nil? u/presence) [feature1 feature2 feature3]))]))]
       [:td.yc-invoice-td.yc-invoice-td--center]
       [:td.yc-invoice-td.yc-invoice-td--center]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format price)]])))

(rum/defc registry-invoice-items [app-atom client-order registry]
  (let [{:client-order/keys [invoice-summary billing-details]} client-order
        {:registry/keys [guest added removed value owing items]} registry
        {:billing/keys [invoice-comments]} billing-details
        {:invoice/keys [vat]} invoice-summary]
    [:h2.yc-heading.yc-heading--medium "Summary of Your Registry"]
    [:table.yc-invoice-table
     [:colgroup
      [:col {:style {:width "300px"}}]
      [:col]
      [:col]
      [:col]]
     [:thead.yc-invoice-thead
      [:tr.yc-invoice-tr
       [:th.yc-invoice-th {:scope "col"} "Items in Registry (at point of closing)"]
       [:th.yc-invoice-th.yc-invoice-th--center {:scope "col"} "Paid by Guests"]
       [:th.yc-invoice-th.yc-invoice-th--center {:scope "col"} "Added by You"]
       [:th.yc-invoice-th.yc-invoice-th--center {:scope "col"} "Removed"]]]
     [:tfoot.yc-invoice-tfoot
      (when (u/presence invoice-comments)
        [:tr.yc-invoice-tr.yc-invoice-tr--comment
         [:td.yc-invoice-td.yc-invoice-td--center {:colSpan "4"} invoice-comments]])
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td]
       [:td.yc-invoice-td {:colspan "2"} [:b "Total value of your gifts:"]]
       [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format value))]]
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td]
       [:td.yc-invoice-td {:colspan "2"} [:b "Paid by Guests:"]]
       [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format guest))]]
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td]
       [:td.yc-invoice-td {:colspan "2"} [:b "Paid by You:"]]
       [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format owing))]]
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td]
       [:td.yc-invoice-td {:colspan "2"} [:b "VAT (included):"]]
       [:td.yc-invoice-td.yc-invoice-td--right (str "R" (u/currency-format vat))]]]
     [:tbody.yc-invoice-tbody
      (when (:registry-item-split/coming items)
        [:fragment
         [:tr.yc-invoice-tr [:th.yc-invoice-th {:colspan "4"} "On its way to You"]]
         (map registry-invoice-line (:registry-item-split/coming items))])
      (when (:registry-item-split/pending items)
        [:fragment
         [:tr.yc-invoice-tr [:th.yc-invoice-th {:colspan "4"} "Out of Stock, but You've Elected to Wait"]]
         (map registry-invoice-line (:registry-item-split/pending items))])

      (when (:registry-item-split/removed items)
        [:fragment
         [:tr.yc-invoice-tr [:th.yc-invoice-th {:colspan "4"} "Paid by Guests and Removed"]]
         (map registry-invoice-line-removed (:registry-item-split/removed items))])
      [:tr.yc-invoice-tr [:th.yc-invoice-th {:colspan "4"} "Totals"]]
      [:tr.yc-invoice-tr
       [:td.yc-invoice-td]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format (- guest removed))]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format added)]
       [:td.yc-invoice-td.yc-invoice-td--center (u/currency-format removed)]]]]))

(rum/defc invoice-view < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)

        registry (cmn/curact action-atom [:registry])
        {:client-order/keys [total-price invoice-date invoice-no client-ref delivery-details billing-details] :as client-order}
        (cmn/curact action-atom [:client-order])]
    (cond
      (:ent/uuid client-order)
      [:div
       [:div.yc-section.yc-section--medium.u-dont-print
        [:div.u-block-center.u-max-width-240
         (buttons/button-web "Print invoice"
           {:href "javascript:javascript:window.print();"
            :style :dark
            :full true
            :size :large})]]

       [:div.yc-section.yc-section--standard
        [:div.yc-document-logo-wrapper
         [:img.yc-simple-image.yc-simple-image--full
          {:alt "Yuppiechef Logo",
           :src
           "https://res.cloudinary.com/yuppiechef/image/upload/v1512052835/ui-resources/shared/stationery/yuppiechef-letterhead-logo.png"}]]]

       [:div.yc-section.yc-section--medium.yc-invoice-section--last
        [:div.yc-invoice
         [:div.yc-invoice-header
          [:h1.yc-heading.yc-heading--medium [:span (if (and total-price (< total-price 0)) "Credit Note" "Tax Invoice")]]
          [:div.yc-row.yc-invoice-row.group
           [:div.yc-column.yc-column--t-1-2.yc-invoice-column.yc-invoice-column--1-2
            [:p.yc-paragraph.yc-paragraph--small
             [:b "Customer Billing Address:"]
             [:br]
             (let [{:delivery/keys [name]} delivery-details
                   {:billing/keys [company-name]} billing-details]
               (cond
                 (u/presence company-name)
                 [:span company-name [:br]]
                 :else
                 (when name [:span name [:br]])))

             (cond
               (:address billing-details)
               (let [{:billing/keys [address city suburb postal-code]} billing-details]
                 (into [:span]
                   (orders-common/address-block [address city suburb postal-code])))

               :else
               (let [{:delivery/keys [address city suburb postal-code]} delivery-details]
                 (into [:span]
                   (orders-common/address-block [address city suburb postal-code]))))
             [:br]
             (when
               (u/presence (:billing/vat-number billing-details))
               [:span [:b "VAT No: "] (:billing/vat-number billing-details)])]]
           [:div.yc-column.yc-column--t-1-2.yc-column--t-right.yc-invoice-column.yc-invoice-column--1-2
            [:ul.yc-list.yc-list--small.u-no-list-bullets.u-text-right
             [:li
              [:b "Tax Date: "] [:span.u-inline-block.u-margin-left-10 (ud/date-format (ud/coerce-date invoice-date) "dd MMM YYYY")]]
             [:li
              [:b (str (if (< total-price 0) "Credit" "Invoice") " Number: ")] [:span.u-inline-block.u-margin-left-10 invoice-no]]
             [:li
              [:b "Our Reference: "]
              [:span.u-inline-block.u-margin-left-10
               [:a.text-link
                [:a (urlstate/href-props app-atom "myaccount" "trackview"
                      {:uuid (:ent/uuid client-order)}) (:ent/display-name client-order)]]]]
             (when (u/presence client-ref)
               [:li
                [:b "Client Reference: "] [:span.u-inline-block.u-margin-left-10 client-ref]])]]]]

         (if registry
           (registry-invoice-items app-atom client-order registry)
           (order-invoice-items app-atom client-order))

         [:div.yc-document-footer
          [:p.yc-paragraph.yc-paragraph--small
           [:b "Yuppiechef Online (Pty) Ltd"]
           [:br]
           "Registration Number: 2007/021383/07"
           [:span.u-pipe "|"]
           "VAT Number: 4410253258"
           [:br]
           "Exporters Code: 21084645 "
           [:span.u-pipe "|"]
           " Liquor Licence Number: WCP/040148"
           [:br]
           "Postal Address: Postnet Suite #132, Private Bag X26, Tokai, South Africa, 7966"
           [:br]
           "Tel: " [:a.text-link.text-link--unmarked {:href "tel:+27217024969"} "+27 (0)21 702 4969"] " "
           [:span.u-pipe "|"]
           "  Email: " [:a.text-link.text-link--unmarked {:href "mailto:hello@yuppiechef.com"} "hello@yuppiechef.com"] " "
           [:span.u-pipe "|"]
           " Web: " [:a.text-link.text-link--unmarked {:href "https://www.yuppiechef.com"} "www.yuppiechef.com"]]
          [:p.yc-paragraph.yc-paragraph--small
           [:b "Yuppiechef Banking Details:"]]
          [:div.group.yc-invoice-bank-details
           [:p.yc-paragraph.yc-paragraph--small
            [:b "First National Bank"]
            [:br]
            "Name: Yuppiechef Online"
            [:br]
            "Account No.: 624-6821-4467"
            [:br]
            "Branch Code: 201109"
            [:br]
            " Acc. Type: Cheque/Current"
            [:br]
            "Swift Code: FIRNZAJJXXX"]]]]]

       [:div.yc-section.yc-section--large.u-dont-print
        [:div.u-block-center.u-max-width-240
         [:div.u-block-center.u-max-width-240
          (buttons/button-web "Print invoice"
            {:href "javascript:javascript:window.print();"
             :style :dark
             :full true
             :size :large})]]]]
      :else
      [:div.yc-section.yc-section--large
       [:h2.yc-heading.yc-heading--medium "Order Invoice"]
       [:div.feedback.feedback--error.ie-group
        {:role "alert"}
        [:div.feedback__icon [:i.icon.icon--block.icon--error.icon--3-2]]
        [:div.feedback__message
         [:h4.feedback-title "Order not found"]
         [:p.feedback-description
          "Sorry, we're unable to find that order. Please check that the order number is correct or go "
          [:a (urlstate/href-props app-atom "myaccount") "back to dashboard"]
          ". If you have any further hassles, please contact "
          [:a {:href "/help.htm"} "customer service."]]]]])))

;; Routing ===================================================================================================================

(defmethod comms/receive :web.invoice/view [app-atom e]
  (swap!
    (cmn/action-cursor app-atom) assoc
    :client-order (:client-order e)
    :registry (:registry e)))

(defmethod flow/render-screen :web.invoice/view [app-atom _]
  [:div.yc-page-content.yc-page-content--standard
   (invoice-view app-atom)])

(defmethod t/transition-open :web.invoice/view [app-atom _ params]
  (let [action-atom (cmn/action-cursor app-atom)]
    (swap! action-atom dissoc :order)
    (comms/ajax-get :web.invoice/view (select-keys params [:uuid :s]))))